import { BaseError } from '@dynamic-labs-sdk/client';

export class NoPhantomSessionError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_phantom_session_error',
      docsUrl: null,
      name: 'NoPhantomSessionError',
      shortMessage: 'No Phantom session found. Please connect first.',
    });
  }
}
